// Textes de la page des emplacements
export const LOCATIONS_TEXTS = {
  title: 'Emplacements',
  addLocation: 'Ajouter un emplacement',
  updateLocation: 'Modifier l\'emplacement',
  name: 'Nom',
  address: 'Adresse',
  city: 'Ville',
  zipcode: 'Code postal',
  organization: 'Organisation',
  sensorCount: 'Capteurs',
  monitored: 'Surveillé',
  loading: 'Chargement des emplacements...',
  errorLoading: 'Erreur lors du chargement des emplacements',
  noLocations: 'Aucun emplacement trouvé',
  rowsPerPage: 'Lignes par page :',
  filterByOrganization: 'Filtrer par organisation',
  selectOrganization: 'Sélectionner une organisation',
  allOrganizations: 'Toutes les organisations',
  search: 'Rechercher des emplacements...',
  searchPlaceholder: 'Rechercher par nom ou ville...',
  chooseOrganization: 'Veuillez sélectionner une organisation pour voir les emplacements',
  errors: {
    LOCATION_NAME_REQUIRED: 'Le nom de l\'emplacement est requis',
    LOCATION_ADDRESS_REQUIRED: 'L\'adresse est requise',
    LOCATION_CITY_REQUIRED: 'La ville est requise',
    LOCATION_ZIPCODE_REQUIRED: 'Le code postal est requis',
    LOCATION_ID_REQUIRED: 'L\'ID de l\'emplacement est requis',
    ZIPCODE_FORMAT_INVALID: 'Format de code postal invalide (utilisez le format : 12345 ou 12345-6789)',
    LOCATION_NAME_EMPTY: 'Le nom de l\'emplacement ne peut pas être vide',
    LOCATION_ADDRESS_EMPTY: 'L\'adresse ne peut pas être vide',
    LOCATION_CITY_EMPTY: 'La ville ne peut pas être vide',
    LOCATION_ZIPCODE_EMPTY: 'Le code postal ne peut pas être vide',
    CREATE_LOCATION_FAILED: 'Échec de la création de l\'emplacement',
    UPDATE_LOCATION_FAILED: 'Échec de la modification de l\'emplacement',
    LOCATION_NOT_FOUND: 'Emplacement non trouvé'
  },
  // Textes du dialogue de document JSON de l'emplacement
  documentDialog: {
    title: 'Document JSON de l\'emplacement',
    locationLabel: 'Emplacement :',
    description: 'Visualisation du document complet de l\'emplacement en format JSON'
  }
} as const;